module.exports = __webpack_public_path__ + "static/media/event-1.9af5e5fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/event-1.jpg
// module id = 547
// module chunks = 0